import React from 'react';
import ReactDOM from 'react-dom';
import history from './history';
import { signOut, logoutModelOpen } from './store/actions';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import createStore from './store/store.config';
import api from '../src/assets/constants/Rafservice.Instance';
import adminApi from '../src/assets/constants/AdminRafservice.Instance';
import aweapi from '../src/assets/constants/AWVRafservice.Instance';
import awesummaryapi from '../src/assets/constants/AWESummaryRafservice.instance';
import awememberdetailsapi from '../src/assets/constants/AWVMemberDetails.RafService.Instance';
import encountersummaryapi from '../src/assets/constants/EncounterSummaryAPI.instance';
import AWVCoderWorkBench from '../src/assets/constants/AWVCoderWorkBenchRafservice.Instance';
import accessKey from '../src/assets/constants/AccessKeyAPI.Instance';

const store = createStore();

const logout = () => {
  store.dispatch(logoutModelOpen());
}

// const logout = () => {
//   store.dispatch(logoutModelOpen());
//   localStorage.clear();  
//   history.push('/');
// }

api.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })

  accessKey.interceptors.request.use(request => {
    let token = localStorage.getItem("Token")
    console.log(localStorage.getItem("Token"))
    request.headers.Authorization = token;
    request.headers['Content-Type'] = 'application/json';
    // // console.log(request);
    return request;
  },
    error => {
      // console.log(error);
      return Promise.reject(error);
    })
    accessKey.interceptors.response.use(response => {
    return response;
  },
    error => {
      if (error && error?.response && error?.response?.status && error?.response?.status == '401') {
        console.log("Error")
        return true;
      }
      return Promise.reject(error);
    })

AWVCoderWorkBench.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })

api.interceptors.response.use(response => {
  //// console.log(response);
  if (response.data) {
    return response.data;
  }
  else {
    return response;
  }
},
  error => {
    // console.log(error);
    if (error && error?.response && error?.response?.status && error?.response?.status == '401') {
      logout();
      return true;
    }
    return Promise.reject(error);
  })

//admin api
adminApi.interceptors.request.use(request => {
  let token = localStorage.getItem("controlAccessToken");
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })
adminApi.interceptors.response.use(response => {
  return response;
},
  error => {
    if (error && error?.response && error?.response?.status && error?.response?.status == '401') {
      logout();
      return true;
    }
    return Promise.reject(error);
  })

aweapi.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })
aweapi.interceptors.response.use(response => {
  return response;
},
  error => {
    if (error && error?.response && error?.response?.status && error?.response?.status == '401') {
      logout();
      return true;
    }
    return Promise.reject(error);
  })

awesummaryapi.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })
awesummaryapi.interceptors.response.use(response => {
  return response;
},
  error => {
    if (error && error?.response && error?.response?.status && error?.response?.status == '401') {
      logout();
      return true;
    }
    return Promise.reject(error);
  })

awememberdetailsapi.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })
awememberdetailsapi.interceptors.response.use(response => {
  return response;
},
  error => {
    if (error && error?.response && error?.response?.status && error?.response?.status == '401') {
      logout();
      return true;
    }
    return Promise.reject(error);
  })

encountersummaryapi.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })
encountersummaryapi.interceptors.response.use(response => {
  return response;
},
  error => {
    if (error && error?.response && error?.response?.status && error?.response?.status == '401') {
      logout();
      return true;
    }
    return Promise.reject(error);
  })

aweapi.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })

awesummaryapi.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })

awememberdetailsapi.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })

encountersummaryapi.interceptors.request.use(request => {
  let token = JSON.parse(localStorage.getItem("Token"));
  request.headers.Authorization = token;
  // // console.log(request);
  return request;
},
  error => {
    // console.log(error);
    return Promise.reject(error);
  })

ReactDOM.render(
  <Provider store={store}>
    <App />,
  </Provider>,
  document.getElementById('root')

);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();